var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikGenerator } from '../../utils/FormikGenerator';
import { useEffect, useState, Fragment } from 'react';
import { Loader } from '../../utils/Loader';
import { Card, Checkbox, FormControlLabel, FormGroup, Popover, Stack, } from '@mui/material';
import { getFiltres } from '../../services/dashboard';
import { CollaborateurIcon, EquipeIcon } from '../../utils/Icons';
import { Typography } from '../../utils/Typography';
import { Button } from '../../utils/Button';
import { getIsMobile } from '../../services/utilisateur';
import { SliderMonth } from '../../utils/SliderMonth';
import { SliderDate } from '../../utils/SliderDate';
export var FiltreStatistique = function (props) {
    var isMobile = getIsMobile();
    var handeOnSearch = props.handeOnSearch, Search = props.Search, _a = props.useSliderMonth, useSliderMonth = _a === void 0 ? true : _a, minDiff = props.minDiff, maxDiff = props.maxDiff;
    var _b = useState([]), filtres = _b[0], setFiltres = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFiltres()];
                    case 1:
                        datas = _a.sent();
                        setFiltres(datas);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var Slider = useSliderMonth ? SliderMonth : SliderDate;
    return (_jsx(Card, __assign({ variant: "outlined", className: "p-small", sx: isMobile ? {} : { width: 180 } }, { children: loading ? (_jsx(Loader, {})) : (_jsx(FormikGenerator, { enableReinitialize: true, datas: Search, additionalInitialValues: ['Debut', 'Fin', 'CollaborateurIds'], fields: [], renderContent: function (_a) {
                var values = _a.values, setFieldValue = _a.setFieldValue;
                var withCollab = function (sectos) {
                    var result = false;
                    for (var _i = 0, sectos_1 = sectos; _i < sectos_1.length; _i++) {
                        var secto = sectos_1[_i];
                        if (secto.Objet !== 'Groupe') {
                            result = true;
                            break;
                        }
                        result = withCollab(secto.sectorisations);
                    }
                    return result;
                };
                var checkIfCollabChecked = function (id) {
                    return (values.CollaborateurIds && values.CollaborateurIds.includes(id));
                };
                var checkIfAllCollabOfGroupeChecked = function (sectos) {
                    return (sectos &&
                        sectos.every(function (secto) {
                            return secto.Objet === 'Groupe'
                                ? checkIfAllCollabOfGroupeChecked(secto.sectorisations)
                                : checkIfCollabChecked(secto.ObjetId);
                        }));
                };
                var getCollaborateurIdsOfGroup = function (sectos) {
                    var ids = [];
                    if (sectos) {
                        for (var _i = 0, sectos_2 = sectos; _i < sectos_2.length; _i++) {
                            var secto = sectos_2[_i];
                            if (secto.Objet === 'Collaborateur') {
                                ids.push(secto.ObjetId);
                            }
                            if (secto.Objet === 'Groupe') {
                                ids.push.apply(ids, getCollaborateurIdsOfGroup(secto.sectorisations));
                            }
                        }
                    }
                    return ids;
                };
                var renderFiltres = function (filtresToDisplay) {
                    return filtresToDisplay
                        .filter(function (filtre) {
                        return filtre.Objet !== 'Groupe' ||
                            withCollab(filtre.sectorisations);
                    })
                        .map(function (filtre) {
                        var sxColor = {
                            color: filtre.Objet === 'Collaborateur'
                                ? 'collaborateur.main'
                                : 'primary.main',
                        };
                        var updateCollab = function (newChecked, ids) {
                            if (newChecked) {
                                setFieldValue('CollaborateurIds', __spreadArray(__spreadArray([], (values.CollaborateurIds
                                    ? values.CollaborateurIds
                                    : []), true), ids, true));
                            }
                            else {
                                setFieldValue('CollaborateurIds', values.CollaborateurIds
                                    ? values.CollaborateurIds.filter(function (id) { return !ids.includes(id); })
                                    : []);
                            }
                        };
                        var checked = false;
                        if (filtre.Objet === 'Collaborateur') {
                            checked = checkIfCollabChecked(filtre.ObjetId);
                        }
                        if (filtre.Objet === 'Groupe') {
                            checked = checkIfAllCollabOfGroupeChecked(filtre.sectorisations);
                        }
                        return (_jsxs(Fragment, { children: [_jsx(FormControlLabel, { onChange: function (e, newChecked) {
                                        if (filtre.Objet === 'Collaborateur') {
                                            updateCollab(newChecked, [filtre.ObjetId]);
                                        }
                                        if (filtre.Objet === 'Groupe') {
                                            var ids = getCollaborateurIdsOfGroup(filtre.sectorisations);
                                            updateCollab(newChecked, ids);
                                        }
                                    }, control: _jsx(Checkbox, { checked: checked }), label: _jsx(Typography, __assign({ variant: "inherit", className: "bold", sx: sxColor, startIcon: filtre.Objet === 'Collaborateur' ? (_jsx(CollaborateurIcon, { sx: sxColor })) : filtre.Objet === 'Groupe' ? (_jsx(EquipeIcon, { sx: sxColor })) : null }, { children: filtre.Libelle })) }), filtre.sectorisations && filtre.sectorisations.length ? (_jsx(Stack, __assign({ className: "ml-medium" }, { children: renderFiltres(filtre.sectorisations) }))) : (_jsx(_Fragment, {}))] }, filtre.Objet + filtre.ObjetId + checked));
                    });
                };
                return (_jsxs(Stack, __assign({ spacing: 2, mt: 1 }, { children: [_jsx(Button, __assign({ "aria-describedby": "popover-collab", onClick: function (e) { return setAnchorEl(e.currentTarget); } }, { children: values.CollaborateurIds && values.CollaborateurIds.length
                                ? values.CollaborateurIds.length === 1
                                    ? '1 collaborateur'
                                    : "".concat(values.CollaborateurIds.length, " collaborateurs")
                                : 'Tous' })), _jsx(Popover, __assign({ id: "popover-collab", open: Boolean(anchorEl), anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            } }, { children: _jsxs(FormGroup, __assign({ className: "p-small" }, { children: [_jsx(FormControlLabel, { onChange: function (e, newChecked) {
                                            setFieldValue('CollaborateurIds', []);
                                        }, control: _jsx(Checkbox, { checked: !values.CollaborateurIds ||
                                                values.CollaborateurIds.length === 0 }), label: _jsx(Typography, __assign({ variant: "inherit", className: "bold", sx: { color: 'primary.main' }, startIcon: _jsx(EquipeIcon, { sx: { color: 'primary.main' } }) }, { children: "Tous" })) }), renderFiltres(filtres)] })) })), _jsx(Slider, { defaultDebut: Search.Debut, defaultFin: Search.Fin, minDiff: minDiff, maxDiff: maxDiff, onChange: function (debut, fin) {
                                setFieldValue('Debut', debut);
                                setFieldValue('Fin', fin);
                            } })] })));
            }, onSubmit: function (newSearch) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    handeOnSearch(newSearch);
                    return [2 /*return*/];
                });
            }); }, submitLabel: "Valider" })) })));
};
//# sourceMappingURL=FiltreStatistique.js.map